module.exports = __webpack_public_path__ + "static/media/rDoji.8edc7f10.png";